import PropTypes from "prop-types";
import Button from "./Button";
import "./style.scss";
import { Icon } from "@mui/material";

const ButtonEdit = (props) => {
  const { children, className, ...attribute } = props;
  return (
    <Button
      color="blue"
      {...{ ...attribute, className: className + " tooltip-button" }}
    >
      <span className="tooltiptext">Chỉnh sửa</span>
      <Icon>edit</Icon> {children}
    </Button>
  );
};

ButtonEdit.propTypes = {
  children: PropTypes.any,
};

ButtonEdit.defaultProps = {};

export default ButtonEdit;
